import { render, staticRenderFns } from "./CommentsDynamic.vue?vue&type=template&id=3ad05dba&scoped=true"
import script from "./CommentsDynamic.vue?vue&type=script&lang=js"
export * from "./CommentsDynamic.vue?vue&type=script&lang=js"
import style0 from "./CommentsDynamic.vue?vue&type=style&index=0&id=3ad05dba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad05dba",
  null
  
)

export default component.exports